import React from 'react'
import { useWebRegisterStatusManager } from '../../../../ng-compat/hooks'
import { LSPayPaymentOption, SalePayment } from './types'
import { OfflinePayment } from './OfflinePaymentModal'

interface Props {
  paymentOptions: LSPayPaymentOption // Replace with the actual type
  onClose: () => void
  onSuccess: (result: SalePayment) => void // Replace with the actual type
}

export const LsPay = ({ paymentOptions, onClose, onSuccess }: Props) => {
  const isOnline = useWebRegisterStatusManager().isOnline()

  if (!isOnline) {
    return (
      <OfflinePayment
        paymentName={paymentOptions.paymentType.name}
        onClose={onClose}
      />
    )
  }
  // add missing props required for LsPay component to use LSPAYPaymentModal.tsx component and handle onSuccess
  return null
}
